// useDestinationAddress.ts
import { useEffect } from 'react'

import { ChainId } from '@src/configs/chainInfo'
import { useExchangeDataContext } from '@src/pages/Exchange/context/ExchangeDataContext'
import { EVMAddress, SolanaAddress, TronAddress } from '@src/types/token'
import { isCrossChainEVMNonEVM } from '@src/utils/chainUtils'

interface UseDestinationAddressProps {
    isCrossChain: boolean
    buyData: {
        chainId: number
    }
    sellData: {
        chainId: number
    }
    evmWalletAddress?: EVMAddress
    solanaWalletAddress?: SolanaAddress
    tronWalletAddress?: TronAddress
}

export function useDestinationAddress({
    isCrossChain,
    buyData,
    sellData,
    evmWalletAddress,
    solanaWalletAddress,
    tronWalletAddress,
}: UseDestinationAddressProps) {
    const { destinationAddress, setDestinationAddress } = useExchangeDataContext()

    useEffect(() => {
        // Reset destination address when chains change
        if (isCrossChain) {
            if (isCrossChainEVMNonEVM(sellData.chainId, buyData.chainId)) {
                switch (buyData.chainId) {
                    case ChainId.Solana:
                        solanaWalletAddress && setDestinationAddress(solanaWalletAddress)
                        break
                    case ChainId.Tron:
                        tronWalletAddress && setDestinationAddress(tronWalletAddress)
                        break
                    default:
                        evmWalletAddress && setDestinationAddress(evmWalletAddress)
                        break
                }
            }
        } else {
            // Reset address if not cross-chain
            setDestinationAddress(undefined)
        }
    }, [isCrossChain, buyData.chainId, sellData.chainId, evmWalletAddress, solanaWalletAddress, tronWalletAddress])

    return {
        destinationAddress,
        setDestinationAddress,
    }
}
